import en from './en.json';
import es from './es.json';

type Locale = Record<string, string>;

const locales: Record<string, Locale> = { en, es };

export function detectLanguage(): string {
  const stored = localStorage.getItem('lang');
  if (stored && locales[stored]) return stored;
  const browser = navigator.language.slice(0, 2);
  return locales[browser] ? browser : 'en';
}

export function translate(lang: string, key: string, vars?: Record<string, string | number>): string {
  const locale = locales[lang] ?? locales.en;
  let str = locale[key] ?? locales.en[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      str = str.replaceAll(`%{${k}}`, String(v));
    }
  }
  return str;
}

export function pluralize(lang: string, baseKey: string, count: number): string {
  const key = count === 1 ? `${baseKey}_one` : `${baseKey}_other`;
  return translate(lang, key, { count });
}

export const supportedLanguages = [
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
] as const;
